import { Card, Col, Form, Input, Row, Typography } from "antd";
import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;

const Requester = ({ getChildData }) => {
  const { t, i18n } = useTranslation();
  
  const validatePhone = useCallback((_, value) => {
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  }, [t]);

  const callparent = (value, name) => {
    getChildData(value, name);
  };

  const validationRules = useMemo(() => ({
    nameOrganization: [
      { required: true, max: 50, message: t("singleRequest:please_enter_first_name_organization") }
    ],
    lastName: [
      { required: true, max: 50, message: t("singleRequest:please_enter_last_name") }
    ],
    email: [
      { required: true, max: 100, message: t("common:please_enter_email") },
      { type: "email", message: t("common:please_enter_valid_email") }
    ],
    phone: [
      { required: true, max: 20, message: t("common:please_enter_phone_number") },
      { validator: validatePhone }
    ],
    address1: [
      { required: true, max: 150, message: t("singleRequest:please_enter_address") }
    ],
    city: [
      { required: true, max: 50, message: t("singleRequest:please_enter_city_name") }
    ],
    state: [
      { required: true, max: 50, message: t("singleRequest:please_enter_state_name") }
    ],
    zipCode: [
      { max: 8, required: true, message: t("singleRequest:please_enter_zip_code") },
      { pattern: /^[0-9]+$/, message: t("singleRequest:zip_code_must_be_numeric") },
      { min: 5, message: t("singleRequest:zip_code_must_be_at_least_5_digits_long") }
    ]
  }), [t, validatePhone]);
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("singleRequest:requester_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:first_name_organization")}
            onChange={(e) => callparent(e.target.value, "RequesterName")}
            name="nameorganization"
            rules={validationRules.nameOrganization}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:last_name")}
            onChange={(e) => callparent(e.target.value, "RequesterLastName")}
            name="RequesterLastName"
            rules={validationRules.lastName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("common:email")}
            name="email"  
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            rules={validationRules.email}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("common:phone_number")}
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            name="phone"
            rules={validationRules.phone}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:address_line_1")}
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            name="address1"
            rules={validationRules.address1}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="address2"
            onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}
            label={t("singleRequest:address_line_2")}
          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            name="city"
            label={t("singleRequest:city")}
            rules={validationRules.city}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label={t("singleRequest:state")}
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            name="state"
            rules={validationRules.state}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="zipcode"
            label={t("singleRequest:zip_code")}
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            rules={validationRules.zipCode}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default Requester;
